import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';

import {
  XrkTable,
  useTableColumn,
  XrkTableRef,
  useInputColumn,
  useSelectColumn,
  BaseDialog,
  BaseTextContent,
  BaseButton
} from 'xrk-components';

import {
  relateProjects,
  customerSelectList
} from '@V/bi-tmpl/src/data-source/apis';

import { date } from '@/utils/formatter';


export default /*#__PURE__*/_defineComponent({
  __name: 'bi-tmpl-project',
  props: {
    remove: {},
    id: {}
  },
  setup(__props: any) {

const props = __props;

const xrkTableRef = ref<XrkTableRef>(null);

const getListAjax = async params => {
  const resp = await relateProjects({
    ...params,
    templateId: props.id
  });
  return resp;
};
const searchConfig = {
  searchColumns: [
    useInputColumn({
      prop: 'projectName',
      type: 'input',
      label: '项目名称',
      style: {
        width: '155px'
      },
      config: {
        placeholder: '请输入项目名称',
        clearable: true
      }
    }),
    useSelectColumn({
      prop: 'customerEntId',
      label: '客户企业',
      style: {
        width: '155px'
      },
      config: {
        placeholder: '请选择客户企业',
        clearable: true,
        filterUseRemote: true,
        remoteMethod: async (val: string) => {
          return await customerSelectList({
            keyword: val,
            templateId: props.id,
            pageNo: 1,
            pageSize: 50
          });
        },
        labelKey: 'customerEntName',
        valueKey: 'customerEntId'
      }
    })
  ],
  resetBtn: {
    show: true,
    text: '重置'
  }
};
const tableConfig = {
  tableColumns: [
    useTableColumn({
      type: 'index',
      label: '序号'
    }),
    useTableColumn({
      label: '项目名称',
      prop: 'projectName',
      showOverflowTooltip: false
    }),
    useTableColumn({
      label: '项目周期',
      prop: 'startDt',
      width: '210px',
      render({ row }) {
        return (
          <span>
            {date(row.startDt, 'date')} - {date(row.endDt, 'date')}
          </span>
        );
      }
    }),
    useTableColumn({
      label: '客户企业',
      prop: 'customerEntName',
      showOverflowTooltip: false
    })
  ].filter(i => !!i)
};

const onCancel = () => {
  props?.remove?.();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    width: "960px",
    title: "关联项目"
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(BaseButton), {
        type: "default",
        onClick: onCancel
      }, {
        default: _withCtx(() => [
          _createTextVNode("关闭")
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(BaseTextContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(XrkTable), {
            ref_key: "xrkTableRef",
            ref: xrkTableRef,
            getListAjax: getListAjax,
            searchConfig: searchConfig,
            tableConfig: tableConfig,
            requestNow: true,
            paginationConfig: {
          paginationPageSize: 15
        }
          }, null, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})